import React, { useState } from "react";
import Header from "../../common/layouts/header/Header";
import Footer from "../../common/layouts/footer/Footer";
import { indexWrapCss, BookPubliCss, BookstroyCss, widthCss } from "./css/Books.style";
import NewTab from "../../common/layouts/newTab/NewTab";
import BookStorytList from "./ui/BookStorytList";
import BookPubliList from "./ui/BookPubliList";

interface Props {
    newBooks: any;
    bookStory: any;
    isMobile?: boolean;
    bookCategory: any;
    onLoadMore: () => void;
    onGenreSelect: (genre: string) => void;
}

const BookStoryLayout = ({ newBooks, bookStory, isMobile = false, bookCategory, onLoadMore, onGenreSelect }: Props) => {
    const [search, setSearch] = useState("");

    const content1 = <NewTab newBooks={newBooks}/>;
    const content2 = <BookStorytList bookStory={bookStory}/>
    const content3 = <BookPubliList
        onGenreSelect={onGenreSelect}
        onLoadMore={onLoadMore}
        bookCategory={bookCategory}
    />

    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    return (
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="book"
            />


            <div
                className={
                    isMobile
                        ? "flex flex-col px-5 gap-[80px] py-[40px] min-w-0"
                        : undefined
                }
                css={!isMobile ? widthCss : undefined}
            >
                {content1}
                {content2}
                {content3}
            </div>

            <Footer/>
        </div>
    );
};

export default BookStoryLayout;
